<template>
    <div id="upload-video">
        <van-uploader :after-read="onAdd" multiple accept = "video/*" > 
            <div>上传视频</div>
        </van-uploader>
    </div>
</template>

<script>
    import * as qiNiu from 'qiniu-js';
    import { setVframe, queryStatus } from '@/api/common';

    import { Uploader, Toast } from 'vant'
    export default {
        name: 'UploadVideo',

        components: {
            [Uploader.name]: Uploader,
            [Toast.name]: Toast,   
        },

        data() {
            return {
                task: null,
                domain: ''
            }
        },

        methods: {
            dataURItoBlob(dataURI) {
                var byteString = atob(dataURI.split(',')[1]);
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                var ab = new ArrayBuffer(byteString.length);
                var ia = new Uint8Array(ab);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ab], {type: mimeString});
            },
            onAdd(file) {
                if(file instanceof Array) {
                    Toast('只支持上传一段视频~');
                    return
                }
                let exist = false;
                
                // if (file.file.name === this.task.name) {
                //     exist = true;
                //     return false;
                // }
                if (!exist) {
                    this.task = {
                        name: file.file.name,
                        status: 0,//0加入，1正在上传， 2完成上传
                        url: '',
                        file: file
                    };
                    this.upload(this.task)
                    Toast.loading({
                        mask: true,
                        message: '上传中...'
                    })
                }   
            },
            upload(task) {
                if (task.status !== 0)
                    return;
                task.status = 1;
                this.$store.dispatch('RefreshQiNiu').then(config => {
                    let key = config.key + '.mp4';
                    let subscription = qiNiu.upload(
                        
                        this.dataURItoBlob(task.file.content),
                        //{size: task.file.size, type: task.file.type}, 
                        key, 
                        config.token, 
                        {
                            params: {
                                userId: this.$store.state.userInfo.userId,
                                type: 'talk'
                            }
                        }, 
                        {
                            useCdnDomain: true,
                            region: qiNiu.region.z2
                        })
                        .subscribe(
                            total => {}, 
                            error => {
                                Toast('上传错误,请重试');
                            }, 
                            response => {
                                // Toast('上传成功');
                                task.status = 2;
                                task.url = `${config.domain}/${key}`;
                                // this.form.album.push(task.url);
                                this.domain = config.domain
                                
                                this.gainVframe({key})
                                
                            });
                            // subscription.unsubscribe() // 上传取消
                });
            },

            async gainVframe({key}) {
                let response = await setVframe({key})
                setTimeout(()=>{
                    queryStatus(response.id).then((res)=>{
                        this.transmitVframe(`${this.domain}/${res.key}`, this.task.url)
                    })
                },1000)
            },

            transmitVframe(vframe,video) {
                this.$emit('receptionVframe',vframe,video)
                Toast.clear()
            }
        }

    }
</script>

<style scoped>
    #upload-video{
        height: 45px !important;
        border-bottom: 1px solid #dad5db;
    }
</style>